import { components } from "@/api-schema";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import i18next from "i18next";
import { Check } from "lucide-react";
import { commonColumns } from "./_constants/common-columns";

export type CasaviContactBlacklistTableType = components["schemas"]["CasaviContactBlacklist"];

export const casaviContactBlacklistTableDefaultColumns = {
  columnElement: {
    id: "element",
    size: 150,
    enableSorting: true,
    header: () => i18next.t("casavi:Element"),
    accessorFn: (row: CasaviContactBlacklistTableType) => row.element,
    cell: (row) => {
      const value = row.getValue() as string;
      const map: Record<string, string> = {
        id: i18next.t("casavi:ElementId"),
        email: i18next.t("casavi:ElementEmail"),
        firstName: i18next.t("common:FirstName"),
        lastName: i18next.t("common:LastName"),
        companyName: i18next.t("casavi:ElementCompanyName"),
      };
      return map[value] || value;
    },
  } as ImplementedAccessorColumnDef<CasaviContactBlacklistTableType, string>,
  columnType: {
    id: "type",
    size: 120,
    enableSorting: true,
    header: () => i18next.t("casavi:Type"),
    accessorFn: (row: CasaviContactBlacklistTableType) => row.type,
    cell: (row) => {
      const value = row.getValue() as string;
      const map: Record<string, string> = {
        regex: i18next.t("casavi:TypeRegex"),
        contains: i18next.t("casavi:TypeContains"),
        full: i18next.t("casavi:TypeFull"),
      };
      return map[value] || value;
    },
  } as ImplementedAccessorColumnDef<CasaviContactBlacklistTableType, string>,
  columnValue: {
    id: "value",
    size: 200,
    enableSorting: true,
    header: () => i18next.t("casavi:Value"),
    accessorFn: (row: CasaviContactBlacklistTableType) => row.value,
    cell: (row) => row.getValue(),
  } as ImplementedAccessorColumnDef<CasaviContactBlacklistTableType, string>,

  columnCaseSensitive: {
    id: "caseSensitive",
    size: 120,
    enableSorting: true,
    header: () => i18next.t("casavi:CaseSensitiveColumn"),
    accessorFn: (row: CasaviContactBlacklistTableType) => row.caseSensitive,
    cell: (row) => {
      const value = row.getValue();
      return value ? <Check className="h-4 w-4" /> : null;
    },
  } as ImplementedAccessorColumnDef<CasaviContactBlacklistTableType, boolean>,

  columnUuid: commonColumns.columnUuid<CasaviContactBlacklistTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<CasaviContactBlacklistTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<CasaviContactBlacklistTableType>(),
};
